import { axios } from 'utils/axios';

export const SavingPlanTypes = {
  Clever: 'clever',
  Premium: 'premium',
} as const;

export interface Plan {
  planName: (typeof SavingPlanTypes)[keyof typeof SavingPlanTypes];
  discountPct: number;
  ruleId: string;
  variantId: string;
}

interface PlanResponse {
  plan_name: (typeof SavingPlanTypes)[keyof typeof SavingPlanTypes];
  discount_pct: number;
  rule_id: string;
  variant_id: string;
}

/**
 * Type guard to check if a plan is from the API (has variant_id)
 */
export const isPlanFromAPI = (plan: Plan | unknown): plan is Plan =>
  plan !== null && typeof plan === 'object' && 'variantId' in plan;

interface Pet {
  name?: string;
  pet_type: string;
  age?: string;
  weight?: string;
  needs?: string[];
}

interface GetSavingsPlansPayload {
  customer_id?: string;
  pets?: Pet[];
}

/**
 * Get savings plans
 */
export const getSavingsPlans = (payload: GetSavingsPlansPayload = {}): Promise<Plan[]> =>
  axios
    .post<PlanResponse[]>('/api/legacy/savings-plans', payload, {
      isPdexApi: true,
    })
    .then(({ data }) => data)
    .then((data) =>
      data.map((plan) => ({
        planName: plan.plan_name,
        discountPct: plan.discount_pct,
        ruleId: plan.rule_id,
        variantId: plan.variant_id,
      }))
    );
